// extracted by mini-css-extract-plugin
module.exports = {"Empty":"autocomplete_Empty__U77wG","NoResults":"autocomplete_NoResults__Dz02k"};